var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('overlay',{attrs:{"show":""}},[_c('popup',_vm._b({on:{"close":_vm.onClose,"back":_vm.onBack,"action":_vm.onAction}},'popup',_vm.$props,false),[_vm._t("main",null,{"slot":"main"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }